import { FC, JSX } from 'react'
import { GroupAvatar, GroupAvatarType } from './GroupAvatar'
import { Table, TableType } from './Table'

export const CompanyContact: FC &
  GroupAvatarType &
  TableType = (): JSX.Element => <></>

CompanyContact.GroupAvatar = GroupAvatar
CompanyContact.Table = Table
